/**
 * 7 pastilles pour visualiser l etat des documents d un dossier :
 * URSSAF, Liasse, Kbis, CNI, Devis, AH, Livre.
 *
 * S1.9 P1-B : un doc avec status `manquant` est rouge avec croix blanche
 * (urgent), tandis que `na` est gris pale (pas encore attendu).
 *
 * P3-A (S2) : 'bloque' compte comme pre-generation pour DEVIS/AH (on ne sait
 * pas si la collecte etait finie au moment du blocage, on prefere afficher `na`
 * gris plutot que `manquant` rouge faussement urgent).
 *
 * La derivation pure est dans `../lib/derivePillStatus.js` (testable sans React).
 */

import { pillStyle } from '../lib/pillStyle.js';
import { derivePillStatus, deriveLivreStatus } from '../lib/derivePillStatus.js';

const PILL_CONFIG = [
  { key: 'urssaf', label: 'URSSAF', generated: false },
  { key: 'liasse_2059_e', label: 'LIASSE', generated: false },
  { key: 'kbis', label: 'KBIS', generated: false },
  { key: 'cni', label: 'CNI', generated: false },
  { key: 'devis', label: 'DEVIS', generated: true },
  { key: 'ah', label: 'AH', generated: true },
  { key: 'livre', label: 'LIVRE', generated: true }, // pseudo doc, calcule depuis velos_livres
];

/**
 * @param {{
 *   docs: Record<string, string>,
 *   velosLivres: number,
 *   velosQuota: number,
 *   dossierStatus?: string,
 * }} props
 */
export default function DocPills({ docs = {}, velosLivres = 0, velosQuota = 0, dossierStatus }) {
  const livreStatus = deriveLivreStatus(velosLivres, velosQuota, dossierStatus);

  return (
    <div className="flex items-center gap-2">
      {PILL_CONFIG.map((p) => {
        const status = p.key === 'livre'
          ? livreStatus
          : derivePillStatus(docs[p.key], p.generated, dossierStatus);
        const { cls, icon } = pillStyle(status);
        return (
          <div key={p.key} className="flex flex-col items-center gap-1">
            <span className="text-[9px] uppercase tracking-wide text-[#64748b] font-medium">
              {p.label}
            </span>
            <div className={`w-6 h-6 rounded-full flex items-center justify-center text-xs font-bold ${cls}`}>
              {icon}
            </div>
          </div>
        );
      })}
    </div>
  );
}
